import { render, staticRenderFns } from "./ReceiveRelated_Row_Items.vue?vue&type=template&id=432cc77c&"
import script from "./ReceiveRelated_Row_Items.vue?vue&type=script&lang=js&"
export * from "./ReceiveRelated_Row_Items.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports